import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { EntityType } from '../../entity.types';
import { Hyperlink } from '../../../components/Hyperlink';
import { UserContext } from '../../../user/UserContext';
import { USER_CURRENT_STATUS } from '../../../../../shared/constants/userStatusConstants';
import { numberWithSpaces } from '../../../utils/math';
import { EntityInfosLawyer } from './EntityInfosLawyer';
import styles from './entity_infos.module.scss';
import {
  EntityBlockSubtitle,
  EntityBlockSubtitleText,
  EntityBlockInfoIcon,
} from '../../components/EntityBlockComponents';

type Props = {
  lawyerId?: string;
  entityName: string;
  decisionCount: number;
  entityType: EntityType;
};

export const EntityInfos: FC<Props> = ({
  entityName,
  lawyerId = '',
  entityType,
  decisionCount,
}) => {
  const {
    currentUser: { status },
    loggedIn,
  } = useContext(UserContext);
  const source = 'entity_more-info';

  const MoreInfoLink = ({ text }: { text: JSX.Element }) => {
    return (
      <Hyperlink
        className={styles.link}
        href={loggedIn ? '/tarifs' : '/'}
        source={source}
      >
        {text}
      </Hyperlink>
    );
  };

  return (
    <EntityBlockSubtitle>
      <EntityBlockInfoIcon />
      <EntityBlockSubtitleText>
        <FormattedMessage
          id="entity/expertises/EntityInfos.tsx/1"
          values={{ count: numberWithSpaces(decisionCount), name: entityName }}
        />
        <br />
        {entityType === 'lawyer' && (
          <EntityInfosLawyer
            source={source}
            lawyerId={lawyerId}
            entityName={entityName}
          />
        )}
        {status !== USER_CURRENT_STATUS.PRO_PLAN && (
          <>
            {entityType === 'lawyer' && (
              <>
                <FormattedMessage id="entity/expertises/EntityInfos.tsx/6" />
                <MoreInfoLink
                  text={
                    <FormattedMessage id="entity/expertises/EntityInfos.tsx/4" />
                  }
                />
              </>
            )}
            {entityType !== 'lawyer' && (
              <MoreInfoLink
                text={
                  <FormattedMessage id="entity/expertises/EntityInfos.tsx/5" />
                }
              />
            )}
          </>
        )}
      </EntityBlockSubtitleText>
    </EntityBlockSubtitle>
  );
};
